import { Component } from '@angular/core';
import { ProductTreeTableViewComponent } from 'gung-standard';

@Component({
    selector: 'otto-olsen-favourite-product-tree-table-view',
    templateUrl: './otto-olsen-favourite-product-tree-table-view.component.html',
    styleUrls: ['./otto-olsen-favourite-product-tree-table-view.component.scss'],
    standalone: false
})
export class OttoOlsenFavouriteProductTreeTableViewComponent extends ProductTreeTableViewComponent { }
